import { render, staticRenderFns } from "./ANewCiudad.vue?vue&type=template&id=79f6163e"
import script from "./ANewCiudad.vue?vue&type=script&lang=js"
export * from "./ANewCiudad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports